import Vue from 'vue'
import {ToastPlugin, ModalPlugin} from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'


//Import Froala Editor

Vue.use(require('vue-shortkey'))

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/flatPickr'
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2)
import moment from 'moment';
import VueMoment from 'vue-moment';

require('moment/locale/tr');
Vue.use(VueMoment, {moment});

// Axios Mock Adapter
import '@/@fake-db/db'

import {ApiService} from './services/ApiService'

ApiService.init(process.env.VUE_APP_API_URL)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)


import Popover from 'vue-js-popover'

Vue.use(Popover)

Vue.directive('uppercase', {
	bind(el, _, vnode) {
		el.addEventListener('input', (e) => {
			e.target.value = e.target.value.toUpperCase()
			vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
		})
	},
})

Vue.directive('no-space', {
	bind(el, _, vnode) {
		el.addEventListener('input', (e) => {
			e.target.value = e.target.value.replace(/\s/g, "")
			vnode.componentInstance.$emit('input', e.target.value.replace(/\s/g, ""))
		})
	},
})

import VueHtml2Canvas from 'vue-html2canvas';

Vue.use(VueHtml2Canvas)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
import '@core/assets/fonts/feather/iconfont.css' // For form-wizard

// import core styles
import '@core/scss/core.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// import assets styles
import '@/assets/scss/style.scss'

Vue.config.productionTip = false

import '@/assets/context-menu.css'


import VueSkeletonLoader from 'skeleton-loader-vue';

Vue.component('vue-skeleton-loader', VueSkeletonLoader);

import 'vue-awesome/icons/bold'
import 'vue-awesome/icons/italic'
import 'vue-awesome/icons/strikethrough'
import 'vue-awesome/icons/underline'
import 'vue-awesome/icons/quote-left'
import 'vue-awesome/icons/code'
import 'vue-awesome/icons/list'
import 'vue-awesome/icons/list-ol'
import 'vue-awesome/icons/indent'
import 'vue-awesome/icons/pen'
import 'vue-awesome/icons/brush'
import 'vue-awesome/icons/highlighter'
import 'vue-awesome/icons/align-center'
import 'vue-awesome/icons/align-justify'
import 'vue-awesome/icons/align-left'
import 'vue-awesome/icons/align-right'
import 'vue-awesome/icons/link'
import 'vue-awesome/icons/plus-circle'
import 'vue-awesome/icons/grip-vertical'
import 'vue-awesome/icons/cloud-upload-alt'
import 'vue-awesome/icons/spinner'
import 'vue-awesome/icons/heading'
import 'vue-awesome/icons/hashtag'
import 'vue-awesome/icons/file-word'
import 'vue-awesome/icons/ellipsis-h'
import 'vue-awesome/icons/sliders-h'

import Icon from 'vue-awesome/components/Icon'
// globally (in your main .js file)
Vue.component('v-icon', Icon)


import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

//
// Icon.register({
//     'table' : {
//         width: 23.868,
//         height: 26,
//         raw: '<path d="M39.5,231h24c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-24c-4.142,0-7.5,3.358-7.5,7.5S35.358,231,39.5,231z"/><path d="M39.5,167h168c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-168c-4.142,0-7.5,3.358-7.5,7.5S35.358,167,39.5,167z"/><path d="M239.5,167h32c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-32c-4.142,0-7.5,3.358-7.5,7.5S235.358,167,239.5,167z"/><path d="M375.5,167h96c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-96c-4.142,0-7.5,3.358-7.5,7.5S371.358,167,375.5,167z"/><path d="M375.5,216c-1.97,0-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.33-2.2,5.3s0.8,3.91,2.2,5.3c1.39,1.4,3.33,2.2,5.3,2.2c1.97,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3s-0.8-3.91-2.2-5.3C379.41,216.8,377.47,216,375.5,216z"/><path d="M380.8,282.2c-1.39-1.4-3.33-2.2-5.3-2.2c-1.97,0-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.33-2.2,5.3s0.8,3.91,2.2,5.3c1.39,1.4,3.33,2.2,5.3,2.2c1.97,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3S382.2,283.59,380.8,282.2z"/><path d="M375.5,344c-1.97,0-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.33-2.2,5.3s0.8,3.91,2.2,5.3c1.39,1.4,3.33,2.2,5.3,2.2c1.97,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3s-0.8-3.91-2.2-5.3C379.41,344.8,377.47,344,375.5,344z"/><path d="M407.5,344c-1.98,0-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.33-2.2,5.3s0.8,3.91,2.2,5.3c1.39,1.4,3.32,2.2,5.3,2.2c1.97,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3s-0.8-3.91-2.2-5.3C411.41,344.8,409.48,344,407.5,344z"/><path d="M375.5,408c-1.97,0-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.33-2.2,5.3s0.8,3.91,2.2,5.3c1.39,1.4,3.33,2.2,5.3,2.2c1.97,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3s-0.8-3.91-2.2-5.3C379.41,408.8,377.47,408,375.5,408z"/><path d="M407.5,408c-1.97,0-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.33-2.2,5.3s0.8,3.91,2.2,5.3c1.39,1.4,3.33,2.2,5.3,2.2c1.97,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3s-0.8-3.91-2.2-5.3C411.41,408.8,409.47,408,407.5,408z"/><path d="M444.8,346.2c-1.39-1.4-3.33-2.2-5.3-2.2c-1.97,0-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.32-2.2,5.3s0.8,3.91,2.2,5.3c1.39,1.4,3.33,2.2,5.3,2.2c1.97,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3S446.2,347.59,444.8,346.2z"/><path d="M412.8,218.2c-1.39-1.4-3.32-2.2-5.3-2.2s-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.33-2.2,5.3s0.8,3.91,2.2,5.3c1.39,1.4,3.33,2.2,5.3,2.2c1.97,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3S414.2,219.59,412.8,218.2z"/><path d="M63.5,408h-24c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h24c4.142,0,7.5-3.358,7.5-7.5S67.642,408,63.5,408z"/><path d="M143.5,103h224c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-224c-4.142,0-7.5,3.358-7.5,7.5S139.358,103,143.5,103z"/><path d="M39.5,295h24c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-24c-4.142,0-7.5,3.358-7.5,7.5S35.358,295,39.5,295z"/><path d="M63.5,344h-24c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h24c4.142,0,7.5-3.358,7.5-7.5S67.642,344,63.5,344z"/><path d="M215.5,344h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,344,215.5,344z"/><path d="M199.5,423h16c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-16c-4.142,0-7.5,3.358-7.5,7.5S195.358,423,199.5,423z"/><path d="M215.5,280h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,280,215.5,280z"/><path d="M199.5,231h16c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-16c-4.142,0-7.5,3.358-7.5,7.5S195.358,231,199.5,231z"/><path d="M247.5,231h32c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-32c-4.142,0-7.5,3.358-7.5,7.5S243.358,231,247.5,231z"/><path d="M303.5,280h-56c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h56c4.142,0,7.5-3.358,7.5-7.5S307.642,280,303.5,280z"/><path d="M263.5,344h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S267.642,344,263.5,344z"/><path d="M247.5,423h32c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-32c-4.142,0-7.5,3.358-7.5,7.5S243.358,423,247.5,423z"/><path d="M471.5,56h-432C17.72,56,0,73.72,0,95.5v320C0,437.28,17.72,455,39.5,455h432c21.78,0,39.5-17.72,39.5-39.5v-320C511,73.72,493.28,56,471.5,56z M175,376v-49h161v49H175z M336,391v49H175v-49H336z M496,135v49H351v-49H496z M336,199v49H175v-49H336z M160,248H15v-49h145V248z M160,263v49H15v-49H160z M175,263h161v49H175V263z M351,263h145v49H351V263z M351,248v-49h145v49H351z M336,184H15v-49h321V184z M15,327h145v49H15V327z M351,327h145v49H351V327z M39.5,71h432c13.509,0,24.5,10.991,24.5,24.5V120H15V95.5C15,81.991,25.991,71,39.5,71z M15,415.5V391h145v49H39.5C25.991,440,15,429.009,15,415.5z M471.5,440H351v-49h145v24.5C496,429.009,485.009,440,471.5,440z"/>',
//     }
// })


Vue.config.performance = true

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app')
